var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _path11, _path12, _path13, _path14, _path15, _path16, _rect2, _path17, _g, _g2, _g3, _path18, _g4, _g5, _path19, _path20, _path21, _path22, _g6, _g7, _path23, _g8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThankGodItsFriday(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "thank_god_its_friday_svg__Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 1040",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".thank_god_its_friday_svg__cls-3,.thank_god_its_friday_svg__cls-4,.thank_god_its_friday_svg__cls-6,.thank_god_its_friday_svg__cls-7,.thank_god_its_friday_svg__cls-8{fill:none}.thank_god_its_friday_svg__cls-9{stroke-width:6px;fill:#f93444}.thank_god_its_friday_svg__cls-13,.thank_god_its_friday_svg__cls-3,.thank_god_its_friday_svg__cls-4,.thank_god_its_friday_svg__cls-6,.thank_god_its_friday_svg__cls-7,.thank_god_its_friday_svg__cls-8,.thank_god_its_friday_svg__cls-9{stroke-linecap:round;stroke-linejoin:round}.thank_god_its_friday_svg__cls-9{stroke:#f93444}.thank_god_its_friday_svg__cls-14{fill:#fa505e}.thank_god_its_friday_svg__cls-15{fill:#024447}.thank_god_its_friday_svg__cls-16{fill:#fff}.thank_god_its_friday_svg__cls-18{fill:#fd934f}.thank_god_its_friday_svg__cls-21{fill:#2a848e}.thank_god_its_friday_svg__cls-3{stroke-width:8px}.thank_god_its_friday_svg__cls-13,.thank_god_its_friday_svg__cls-4,.thank_god_its_friday_svg__cls-6,.thank_god_its_friday_svg__cls-7,.thank_god_its_friday_svg__cls-8{stroke-width:16px}.thank_god_its_friday_svg__cls-8{stroke:#cae0e3}.thank_god_its_friday_svg__cls-13{fill:#006c78}.thank_god_its_friday_svg__cls-13,.thank_god_its_friday_svg__cls-6{stroke:#006c78}.thank_god_its_friday_svg__cls-3,.thank_god_its_friday_svg__cls-7{stroke:#fff}.thank_god_its_friday_svg__cls-4{stroke:#fa505e}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-9",
    d: "M774.72 648.41l-83.94-65.1c-15.83-12.27-38.85-1-38.85 19.03v126.8h95.16c24.91 0 45.09-20.19 45.09-45.09 0-13.94-6.44-27.09-17.46-35.63z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-21",
    d: "M122.71 488.61c-7.45 7.45-19.65 7.45-27.1 0l-42.2-42.01c-7.45-7.45-7.45-19.65 0-27.1 7.45-7.45 19.65-7.45 27.1 0l42.2 42.01c7.45 7.45 7.45 19.65 0 27.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-21",
    d: "M127.92 487c10.36 1.93 20.42-4.96 22.36-15.32l10.82-58.76c1.93-10.36-4.96-20.42-15.32-22.36-10.36-1.93-20.42 4.96-22.36 15.32l-10.82 58.76c-1.93 10.36 4.96 20.42 15.32 22.36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-21",
    d: "M150.28 471.67l2.63-2.82c9.06-9.72 24.07-10.83 34.46-2.55 11.87 9.46 12.86 27.14 2.13 37.87l-3.62 3.62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-21",
    d: "M147.6 464.72c-21.26-16.24-52.1-6.24-59.99 19.33-20.6 66.77 1.1 142.19 59.87 187.09 73.33 56.02 177.34 43.85 235.92-26.28L147.59 464.73z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-6",
    d: "M87.61 484.05c-20.6 66.77 1.1 142.19 59.87 187.09M165.67 509.7l-11.45 11.38c-7.31 7.27-19.09 7.36-26.51.2-7.66-7.39-7.73-19.63-.17-27.11l22.74-22.49 10.82-58.76c1.93-10.36-4.96-20.42-15.32-22.36-10.36-1.93-20.42 4.96-22.36 15.32l-8.73 47.6-33.8-33.62c-7.55-7.55-20.2-7.84-27.65-.18-7.27 7.47-7.21 19.53.18 26.92l35.24 35.06"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-21",
    d: "M685.6 457.35V779c0 62.9-48.41 114.51-110 119.58-3.29.28-6.63.42-10 .42H348.07c-3.37 0-6.71-.14-10-.42-61.6-5.07-110-56.68-110-119.58V457.35c0-126.34 102.42-228.76 228.76-228.76 63.17 0 120.36 25.6 161.76 67 41.4 41.4 67.01 98.59 67.01 161.76z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-18",
    d: "M559 886.71h100.12c17.83 0 32.31 14.48 32.31 32.31v21.02c0 6.23-5.06 11.29-11.29 11.29H559c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z",
    transform: "rotate(-180 609.06 919.02)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-4",
    d: "M525.69 887l1 32.02c0 17.77 14.54 32.31 32.31 32.31h100.12c17.77 0 32.31-14.54 32.31-32.31"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-16",
    d: "M575.6 783.4V631.63c0-65.53-52.53-119.69-118.06-120.07-65.81-.39-119.47 53.03-119.47 118.76V783.4c0 41.75 33.85 75.6 75.6 75.6H500c41.75 0 75.6-33.85 75.6-75.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thank_god_its_friday_svg__cls-16",
    x: 317.16,
    y: 388.75,
    width: 118.93,
    height: 168.19,
    rx: 59.46,
    ry: 59.46
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-9",
    d: "M338.07 761.14V596.26c0-11.05-8.95-20-20-20h-98v204.88h98c11.05 0 20-8.95 20-20zM575.6 761.14V596.26c0-11.05 8.95-20 20-20h90c4.42 0 8 3.58 8 8v196.88h-98c-11.05 0-20-8.95-20-20z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-21",
    d: "M519.25 161.08c17.34 0 31.42 14.08 31.42 31.42v93.43c0 17.34-14.08 31.42-31.42 31.42h-31.42V192.51c0-17.34 14.08-31.42 31.42-31.42z",
    transform: "rotate(45 519.246 239.209)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M337.72 358.98c9.98-9.98 23.75-16.18 38.9-16.18 15.15 0 28.91 6.2 38.9 16.18",
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-6",
    d: "M486.5 345.18c12.97-12.97 30.86-21.02 50.54-21.02s37.57 8.05 50.54 21.02"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-14",
    d: "M411 735.68c-13.24 9.45-31.62-.02-31.62-16.28v-55.35c0-16.26 18.38-25.73 31.62-16.28l20.53 14.65c20.12 14.36 20.12 44.25 0 58.61L411 735.68zM502.67 735.68c13.24 9.45 31.62-.02 31.62-16.28v-27.67-27.67c0-16.26-18.38-25.73-31.62-16.28l-20.53 14.65c-20.12 14.36-20.12 44.25 0 58.61l20.53 14.65z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 16,
    stroke: "#f93444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    d: "M405.2 691.72h103.26"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thank_god_its_friday_svg__cls-14",
    x: 438.67,
    y: 673.56,
    width: 36.32,
    height: 36.32,
    rx: 10,
    ry: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M464.99 673.56c5.52 0 10 4.48 10 10v16.32c0 5.52-4.48 10-10 10h-16.32c-5.52 0-10-4.48-10-10v-16.32c0-5.52 4.48-10 10-10h16.32m0-16h-16.32c-14.34 0-26 11.66-26 26v16.32c0 14.34 11.66 26 26 26h16.32c14.34 0 26-11.66 26-26v-16.32c0-14.34-11.66-26-26-26z",
    fill: "#f93444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-16",
    d: "M436.08 462.24v-14.03c0-32.7-26.76-59.46-59.46-59.46-32.71 0-59.46 26.76-59.46 59.46v14.03h118.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-15",
    d: "M386.62 526.94c-16.25 0-29.46-13.22-29.46-29.46v-49.26c0-16.25 13.22-29.46 29.46-29.46s29.46 13.22 29.46 29.46v49.26c0 16.25-13.22 29.46-29.46 29.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-16",
    d: "M396.67 476.3l19.44 11.22c2.67 1.54 6-.38 6-3.46v-22.45c0-3.08-3.33-5-6-3.46l-19.44 11.22c-2.67 1.54-2.67 5.39 0 6.93z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "thank_god_its_friday_svg__cls-16",
    x: 477.58,
    y: 388.75,
    width: 118.93,
    height: 168.19,
    rx: 59.46,
    ry: 59.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-21",
    d: "M442.03 465.92v-15.44c0-35.98-29.43-65.41-65.41-65.41s-65.41 29.43-65.41 65.41v15.44h130.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-15",
    d: "M527.04 526.94c-16.25 0-29.46-13.22-29.46-29.46v-49.26c0-16.25 13.22-29.46 29.46-29.46s29.46 13.22 29.46 29.46v49.26c0 16.25-13.22 29.46-29.46 29.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-16",
    d: "M517 476.3l-19.44 11.22c-2.67 1.54-6-.38-6-3.46v-22.45c0-3.08 3.33-5 6-3.46L517 469.37c2.67 1.54 2.67 5.39 0 6.93z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-21",
    d: "M462.73 142.46c17.34 0 31.42 14.08 31.42 31.42v93.43c0 17.34-14.08 31.42-31.42 31.42h-31.42V173.89c0-17.34 14.08-31.42 31.42-31.42z",
    transform: "rotate(45 462.73 220.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-6",
    d: "M473.54 165.35c12.22-12.22 32.21-12.22 44.43 0 12.22 12.22 12.22 32.21 0 44.43l-50.92 50.92"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-21",
    d: "M602.45 465.92v-15.44c0-35.98-29.43-65.41-65.41-65.41s-65.41 29.43-65.41 65.41v15.44h130.82z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-15",
    d: "M260.44 439.82h4.05v37.21h172.46v-17.32c0-10.99 8.91-19.89 19.89-19.89 10.99 0 19.89 8.91 19.89 19.89v17.32h172.46v-37.21h5.93c6.08 0 11-4.92 11-11v-17.94c0-6.08-4.92-11-11-11H260.44c-6.08 0-11 4.92-11 11v17.94c0 6.08 4.92 11 11 11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-15",
    d: "M336.21 424H224.69c-5.36 0-10.07 3.52-11.6 8.65l-9.9 33.33c-2.34 7.87 3.56 15.77 11.77 15.77 5.43 0 10.22-3.57 11.77-8.78l6.94-23.37h102.55v-25.61zM580.04 424h111.52c5.36 0 10.07 3.52 11.6 8.65l9.9 33.33c2.34 7.87-3.56 15.77-11.77 15.77-5.43 0-10.22-3.57-11.77-8.78l-6.94-23.37H580.03v-25.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-15",
    d: "M264.48 411.25h172.46v93.54c0 30.36-24.64 55-55 55h-62.46c-30.36 0-55-24.64-55-55v-93.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-13",
    d: "M300.09 422.93h72.65c15.78 0 28.6 12.82 28.6 28.6v62.46c0 15.78-12.82 28.6-28.6 28.6h-72.65V422.93z",
    transform: "rotate(90 350.71 482.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-15",
    d: "M531.72 411.25h62.46c30.36 0 55 24.64 55 55v93.54H476.72v-93.54c0-30.36 24.64-55 55-55z",
    transform: "rotate(-180 562.95 485.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-13",
    d: "M512.33 422.93h72.65c15.78 0 28.6 12.82 28.6 28.6v62.46c0 15.78-12.82 28.6-28.6 28.6h-72.65V422.93z",
    transform: "rotate(90 562.95 482.76)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-16",
    d: "M419.34 433.73l-46.22 46.22c-9.07 9.07-9.07 23.78 0 32.85 4.54 4.54 10.48 6.8 16.43 6.8s11.89-2.27 16.43-6.8l13.37-13.37v-65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-15",
    d: "M378.26 421.32v-.48l-71.68 71.68c-7.45 7.45-7.45 19.53 0 26.99 3.73 3.73 8.61 5.59 13.49 5.59s9.77-1.86 13.49-5.59l98.18-98.18h-53.49zM327.9 412.98v-.21l-31.49 31.49c-3.27 3.27-3.27 8.58 0 11.85 1.64 1.64 3.78 2.46 5.93 2.46s4.29-.82 5.93-2.46l43.13-43.13h-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-7",
    d: "M356.53 441.57l-43.42 43.42"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-16",
    d: "M631.58 433.73l-46.22 46.22c-9.07 9.07-9.07 23.78 0 32.85 4.54 4.54 10.48 6.8 16.43 6.8s11.89-2.27 16.43-6.8l13.37-13.37v-65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-15",
    d: "M590.5 421.32v-.48l-71.68 71.68c-7.45 7.45-7.45 19.53 0 26.99 3.73 3.73 8.61 5.59 13.49 5.59s9.77-1.86 13.49-5.59l98.18-98.18h-53.49zM540.14 412.98v-.21l-31.49 31.49c-3.27 3.27-3.27 8.58 0 11.85 1.64 1.64 3.78 2.46 5.93 2.46s4.29-.82 5.93-2.46l43.13-43.13h-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-7",
    d: "M568.77 441.57l-43.42 43.42"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-18",
    d: "M431.17 501.98h51.71c15.7 0 28.45 12.75 28.45 28.45v20.72c0 29.97-24.33 54.3-54.3 54.3s-54.3-24.33-54.3-54.3v-20.72c0-15.7 12.75-28.45 28.45-28.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-14",
    d: "M457.02 585.44c-18.91 0-34.3-15.39-34.3-34.3v-20.72c0-4.58 3.87-8.45 8.45-8.45h51.71c4.58 0 8.45 3.87 8.45 8.45v20.72c0 18.91-15.39 34.3-34.3 34.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.73,
    y: 500.62,
    width: 114.2,
    height: 51.32,
    rx: 25.66,
    ry: 25.66,
    fill: "#fed425"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-9",
    d: "M313.42 694.93V591.4l-110.03-84.05c-1.76-1.35-4.28-1-5.62.76l-93.88 124.04c-1.04 1.37-1.1 3.26-.12 4.67 10.62 15.38 23.67 29.09 38.85 40.68a7.952 7.952 0 004.85 1.64c2.41 0 4.79-1.08 6.36-3.14.04-.05.07-.1.11-.16 48.14 33.4 107.99 38.86 159.47 19.09z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-4",
    d: "M259.67 737.43l26.74-26.73"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-18",
    d: "M381.12 879.35h-44.84c-19.79 0-35.99 16.19-35.99 35.99 0 19.79 16.19 35.99 35.99 35.99h44.84c19.79 0 35.99-16.19 35.99-35.99 0-19.79-16.19-35.99-35.99-35.99z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-4",
    d: "M381.12 879.35h-44.84c-19.79 0-35.99 16.19-35.99 35.99 0 19.79 16.19 35.99 35.99 35.99h44.84c19.79 0 35.99-16.19 35.99-35.99"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-3",
    d: "M223.09 559.53v17.29M231.73 568.17h-17.29M260.69 634.73v17.29M269.34 643.37h-17.29M321.12 737.25v17.29M329.77 745.89h-17.29M128.3 590.57v17.29M136.94 599.22h-17.29"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#cae0e3",
    d: "M628.04 647.38l68.46-69.32H559.58l68.46 69.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff4c9",
    d: "M579.9 593.12l48.14 52.9 48.14-52.9H579.9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fed425",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    d: "M701.86 528.94L610.9 619.9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650.21,
    y: 546.92,
    width: 38.37,
    height: 29.34,
    rx: 14.67,
    ry: 14.67,
    transform: "rotate(-45 669.397 561.587)",
    strokeWidth: 8,
    fill: "#93c731",
    stroke: "#93c731",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-8",
    d: "M628.04 647.38l68.46-69.32H559.58l68.46 69.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-8",
    d: "M628.04 647.38l68.46-69.32H559.58l68.46 69.32z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cae0e3",
    strokeWidth: 16,
    fill: "#cae0e3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M628.04 714.27l-37.15 24.04h74.3l-37.15-24.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-8",
    d: "M628.04 647.38v87.77"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-21",
    d: "M694.13 652.02h-37.41c-21.77 0-39.59 17.82-39.59 39.59 0 21.78 17.82 39.59 39.59 39.59h37.41c5.52 0 10-4.48 10-10v-59.18c0-5.52-4.48-10-10-10z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "thank_god_its_friday_svg__cls-3",
    d: "M768.05 679.1v17.29M759.4 687.75h17.29M595.51 660.72v17.29M586.86 669.37h17.29M706.51 644.42v17.29M697.86 653.07h17.29"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankGodItsFriday);
export default ForwardRef;